import { getBodyCookieSettings, setBodyCookieSettings } from '~/src/shared/utils/cookies'

import CookiesManager from '@cookieManage/services/CookiesManager'
import { CookieSettings } from '@cookieManage/types/CookieManage.interface'

import { isInViewport } from '../../shared/utils/jquery'

import { PurchasingOption } from './offerbox/purchasing_option'
import { PurchasingOptionBuyNow } from './offerbox/purchasing_option_buy_now'
import { PurchasingOptionLeaseToOwn } from './offerbox/purchasing_option_lease_to_own'
import { PurchasingOptionMakeOffer } from './offerbox/purchasing_option_make_offer'
import { PurchasingOptionRent } from './offerbox/purchasing_option_rent'

const SHOW_FOOTER_EARLIER_PX = 200

// Attach the behavior to the offerbox layout
export function jqOfferBoxBehavior() {
  // attach behavior and validation to each possible option in the offerbox
  $('.offer-box #buyNow.purchasing-option').each(function () {
    $(this).data('purchase-option', new PurchasingOptionBuyNow(this))
  })

  $('.offer-box #rentDomain.purchasing-option').each(function () {
    $(this).data('purchase-option', new PurchasingOptionRent(this))
  })

  $('.offer-box #makeOffer.purchasing-option').each(function () {
    const option = new PurchasingOptionMakeOffer(this)
    $(this).data('purchase-option', option)
  })

  $('.offer-box #leaseToOwn.purchasing-option').each(function () {
    $(this).data('purchase-option', new PurchasingOptionLeaseToOwn(this))
  })

  $('.offer-box .purchaseAction').on('click', function (event) {
    const gaCategory = $('.offer-box').data('ga-category')
    const gaLabel = $('.offer-box').data('ga-label')
    const gaAction = `${$(this).data('ga-purchasing-type')} Click Next`

    window.AnalyticsEvent(gaAction, gaCategory, gaLabel)
  })

  // activate the next button, depending on if the last updated option is in a valid state
  $('.offer-box').each(function () {
    $(this).on('purchase-option', (event, option: PurchasingOption) => {
      setNextButton(option)
    })

    $(this).on('purchase-option-activate', (event, option: PurchasingOption) => {
      sendGAOptionClick(option)
    })

    $(this).on('submit', (event, option: PurchasingOption) => {
      setNextButton(option)
      $('.offer-box .purchaseAction')[0].click()
    })
  })

  $(".offer-box [data-toggle='collapse']").first().trigger('click')
  $('.offer-box').data('init', 'done')

  $(document).ready(() => {
    const footer = $('footer')
    const defaultFooterPaddingBottom = parseFloat(footer.css('padding-bottom'))
    const offerBoxFooterID = '#fixed-offerbox-footer'
    const stickyFooterHeight = $(offerBoxFooterID).height() || 0
    const bodyClassName = '--with-sticky-footer'

    const switchStickyFooter = () => {
      const offerBoxMainID = '#offerbox-main'

      if ($(offerBoxMainID).length === 0) return

      if (isInViewport($(offerBoxMainID), -SHOW_FOOTER_EARLIER_PX)) {
        $(offerBoxFooterID).removeClass('d-block')
        footer.css('padding-bottom', `${defaultFooterPaddingBottom}px`)
        $('body').removeClass(bodyClassName)
      } else {
        $(offerBoxFooterID).addClass('d-block')
        $('body').addClass(bodyClassName)
        footer.css('padding-bottom', `${defaultFooterPaddingBottom + stickyFooterHeight}px`)
      }
    }

    switchStickyFooter()
    $(window).on('scroll', switchStickyFooter)
  })
}

function sendGAOptionClick(option: PurchasingOption) {
  if ($('.offer-box').data('init') !== 'done') {
    return
  }

  const gaCategory = $('.offer-box').data('ga-category')
  const gaLabel = $('.offer-box').data('ga-label')
  const gaAction = `${option.gaPurchasingType} Click`

  window.AnalyticsEvent(gaAction, gaCategory, gaLabel)
}

function sendGANext(option: PurchasingOption) {
  const gaCategory = $('.offer-box').data('ga-category')
  const gaLabel = $('.offer-box').data('ga-label')
  const gaAction = `${option.gaPurchasingType} Click Next`

  window.AnalyticsEvent(gaAction, gaCategory, gaLabel)
}

/** Set the next button behavior on the offerbox */
function setNextButton(option: PurchasingOption) {
  $('.offer-box .purchaseAction').data('ga-purchasing-type', option.gaPurchasingType)
  const cookieSettingsUrl = getBodyCookieSettings()
  const url = cookieSettingsUrl ? `${option.url}&${cookieSettingsUrl}` : option.url

  const button = $('.offer-box .purchaseAction')
  if (option.valid) {
    button.removeAttr('disabled')
    button.attr('href', url)
  } else {
    button.attr('disabled', 'true')
    button.attr('href', 'javascript: void(0)')
  }
}

function getTargetOption() {
  const activeOption = $('.purchasing-option.active')
  if (activeOption.length !== 0) return activeOption

  const firstOption = $('.purchasing-option').first()
  if (firstOption.length !== 0) return firstOption

  return undefined
}

export function onAcceptCookies(settings: CookieSettings) {
  const option = getTargetOption()
  if (!option) return

  const optionData = $(option).data('purchase-option')

  setBodyCookieSettings(settings)
  setNextButton(optionData)
}

$(() => {
  const cookiePermission = CookiesManager.getCookiePermission()

  if (cookiePermission) {
    const cookieSettings = CookiesManager.getCookieSettings()
    onAcceptCookies(cookieSettings)
  }
})
